export default __webpack_public_path__ + "static/media/promission-seeAdds.e992a8d5.png";